import * as React from "react";
import classNames from "classnames";
import Icon from "../../icons/icon";
import Spinner from "~/components/spinner/spinner";

interface IAccordionHeaderProps {
    onClick?: (activeIndex: number | undefined) => void;
    isActive?: boolean;
    isDisabled?: boolean;
    isLoading?: boolean;
    hideIcon?: boolean;
    index?: number;
    className?: string;
    tabIndex?: number | undefined;
}

const AccordionHeader: React.FC<IAccordionHeaderProps> = props => {
    const baseClass = "accordion-header";
    const rootClasses = classNames(baseClass, props.className, {
        [`${baseClass}--isActive`]: props.isActive,
        [`${baseClass}--isDisabled`]: props.isDisabled,
        [`${baseClass}--isLoading`]: props.isLoading
    });

    return (
        <div
            className={rootClasses}
            tabIndex={props.tabIndex}
            onClick={() => props.onClick && props.onClick(props.index)}
            onKeyPress={event => {
                if (event.key === "Enter") {
                    return props.onClick && props.onClick(props.index);
                }
            }}
        >
            {props.children}

            {!props.hideIcon && (
                <div className={`${baseClass}__icon-wrapper`}>
                    <Spinner />

                    <Icon
                        className={`${baseClass}__icon`}
                        iconId={props.isActive ? "icon_16_arrow-up" : "icon_16_arrow-down"}
                    />
                </div>
            )}
        </div>
    );
};

export default AccordionHeader;
